// Visitantes recientes (GET /admin/public-tracking/visitors) — cada fila abre su ficha
// (línea de tiempo: fuente → páginas → registro → pago → conversación).
import React, { useEffect, useState } from 'react';
import { Users, ChevronRight } from 'lucide-react';
import type { VisitorList } from '@/modules/public-tracking/api';

const CHANNEL: Record<string, string> = {
  whatsapp: 'WhatsApp', facebook: 'Facebook', instagram: 'Instagram', google: 'Google', linkedin: 'LinkedIn',
  tiktok: 'TikTok', email: 'Correo', directo: 'Directo', otro: 'Otro sitio',
};
const when = (iso: string) => {
  try {
    return new Date(iso).toLocaleString('es-MX', { timeZone: 'America/Mexico_City', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
  } catch {
    return iso;
  }
};

export const CampaignVisitors: React.FC<{
  days: number;
  load: (days: number) => Promise<VisitorList>;
  onOpen: (visitorId: string) => void;
}> = ({ days, load, onOpen }) => {
  const [data, setData] = useState<VisitorList | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let alive = true;
    setError('');
    load(days).then((d) => alive && setData(d)).catch((e: any) => alive && setError(e?.message || 'No se pudo cargar.'));
    return () => {
      alive = false;
    };
  }, [days, load]);

  return (
    <div className="rounded-xl border border-border bg-card text-card-foreground p-4 md:p-5 min-w-0">
      <h3 className="font-semibold flex items-center gap-2"><Users className="h-4 w-4 text-primary" />Visitantes recientes</h3>
      <p className="text-xs text-muted-foreground mt-0.5">Toca uno para ver su recorrido completo: de dónde llegó, qué vio, si se registró, pagó o conversó.</p>
      {error && <p className="mt-3 text-sm text-destructive">{error}</p>}
      {!data && !error && <p className="mt-3 text-sm text-muted-foreground">Cargando…</p>}
      {data && (data.visitors.length ? (
        <ul className="mt-3 divide-y divide-border">
          {data.visitors.slice(0, 25).map((v) => (
            <li key={v.visitor_id}>
              <button type="button" onClick={() => onOpen(v.visitor_id)}
                className="w-full flex items-center gap-3 py-2 text-left text-sm hover:bg-muted/50 rounded-md px-1">
                <span className="w-24 shrink-0 text-xs text-muted-foreground tabular-nums">{when(v.last_seen)}</span>
                <span className="min-w-0 flex-1">
                  <span className="font-medium">{CHANNEL[v.channel || ''] || v.channel || '—'}</span>
                  {v.utm_campaign && <span className="text-muted-foreground"> · {v.utm_campaign}{v.utm_content ? ` · ${v.utm_content}` : ''}</span>}
                  <span className="block text-xs text-muted-foreground font-mono truncate">{v.last_path || '/'}</span>
                </span>
                <span className="text-xs text-muted-foreground tabular-nums shrink-0">{v.events_count} ev.</span>
                <ChevronRight className="h-4 w-4 text-muted-foreground shrink-0" />
              </button>
            </li>
          ))}
        </ul>
      ) : <p className="mt-3 text-sm text-muted-foreground">Sin visitantes en este periodo.</p>)}
    </div>
  );
};

export default CampaignVisitors;
